<template>
  <div>
     <div class="font-semibold">
            Does this action/form need to be approved by all approvers or just one
            approver needs to approve ?
          </div>
          <div class="flex my-3 flex-row">
            <span
              ><b-form-radio
                v-model="everyOneApprove"
                name="approval-flow"
                value="yes"
                >Yes, everyone needs to approve.</b-form-radio
              ></span
            >
            <span class="mx-5"
              ><b-form-radio
                v-model="everyOneApprove"
                name="approval-flow"
                value="no"
                >No, action/form needs only a single Aapproval to be
                confirmed.</b-form-radio
              ></span
            >
          </div>
          <div class="flex flex-row my-3 overflow-x-auto flex-no-wrap">
            <div
              style="width: 450px; min-width: 450px"
              class="flex flex-row"
              v-for="(approver, i) in approvalBox"
              :key="i"
            >
              <div
                class="border mr-4 rounded p-3"
                style="width: 360px; min-width: 360px"
              >
                <div class="flex flex-row justify-between">
                  <span class="flex flex-row">
                    <span class="mr-3">{{ i + 1 }}</span>
                    <span class="font-bold text-xs">Approver {{ i + 1 }}</span>
                    </span>
                    <span v-if="approvalBox.length > 1" @click="removeApprover(i)" class="font-bold text-xs"><img src="./partials/close.svg" alt=""
                  /></span>
                </div>
                <div class="my-3">
                    <base-input placeholder="Enter email, name or designation..." type="text"></base-input>
                </div>
                <div class="mt-4">
                    <hr />
                </div>
                <div class="flex mt-3 mb-0 flex-row justify-between">
                    <b-form-checkbox class="text-sm">Authorized Signatory</b-form-checkbox>
                    <base-button background="white" text="Add" color="text-primary-yellow"></base-button>
                </div>
            </div>
            <div class="my-auto flex flex-row mx-3">
                <img src="./partials/arrow.svg" alt="" />
            </div>
        </div>
    
        <div @click="addApprover" class="my-auto flex flex-row text-primary-yellow">
            <img src="./partials/add.svg" alt="" />
            <span class="mx-2"> Add Approver </span>
        </div>
    </div>
    <div v-if="everyOneApprove === 'no'">
        <div class="text-sm">
            Approval Flow is configured in an ascending order, i.e. Highest number being the last approver. Please confirm that you have arranged your approvers accordingly before proceeding.
        </div>
        <hr class="my-3" />
    
        <div class="text-lg font-semibold">Escalation Settings (Optional)</div>
        <div class="text-sm my-3">
            Escalate approval when approvers are unavailable or have failed to approve within the set time limit.
        </div>
        <div class="my-3">
            <div>
                <label class="text-sm">Time Limit</label>
                <div class="flex flex-row">
                    <base-input type="number" style="width: 96px" width="w-24"></base-input>
                    <el-select filterable v-model="state" style="width: 108px; margin-left: 10px" placeholder="Hour(s)">
                        <el-option label="Hour" value="state.name"> </el-option>
                        <el-option label="Day" value="state.name"> </el-option>
                    </el-select>
                </div>
                <div class="text-sm">
                    Add approvers to see escalation settings here...
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
data(){
    return{
        approvalBox: [{
                name: "",
            }, ],
            everyOneApprove: "yes",
    }
},
methods:{
    addApprover() {
            this.approvalBox.push({
                name: "",
            });
        },
        removeApprover(index) {
            this.approvalBox.splice(index, 1);
        },
}
}
</script>

<style>

</style>